import { Controller } from "@hotwired/stimulus"
import { OnboardingStepModel } from "~/deprecated/models/onboarding_step"

export default class extends Controller {
  static values = { id: String, dismissDefinitely: String }

  close() {
    this.element.remove()

    if(this.dismissDefinitelyValue === "true") {
      const onboardingStep = new OnboardingStepModel()
      onboardingStep.save({ name: this.idValue, seen: true })
    }
  }
}
